import { z } from 'zod';

// Where the value came from (Herkunft in the Objektaufnahmebogen).
export const FACT_ORIGINS = ['OWNER_STATEMENT', 'EXTERNAL', 'ON_SITE', 'DOCUMENT', 'PHOTO', 'MEMBER'] as const;
export type FactOrigin = (typeof FACT_ORIGINS)[number];

// How well the value is backed.
export const FACT_STATUSES = ['PROVEN', 'ASSUMED', 'CONTRADICTED', 'UNKNOWN', 'NOT_APPLICABLE'] as const;
export type FactStatus = (typeof FACT_STATUSES)[number];

// The statuses under which a fact may have no value.
export const VALUE_LESS_FACT_STATUSES = ['UNKNOWN', 'NOT_APPLICABLE'] as const satisfies ReadonlyArray<FactStatus>;

// How far it has been checked (Prüfstufe).
export const FACT_REVIEW_LEVELS = ['AI_DETECTED', 'MEMBER_CONFIRMED'] as const;
export type FactReviewLevel = (typeof FACT_REVIEW_LEVELS)[number];

// NONE = not read from a medium (owner statement, external register, on-site capture, member entry).
export const FACT_MODALITIES = ['DOCUMENT', 'IMAGE', 'NONE'] as const;
export type FactModality = (typeof FACT_MODALITIES)[number];

export const FactOriginSchema = z.enum(FACT_ORIGINS);
export const FactStatusSchema = z.enum(FACT_STATUSES);
export const FactReviewLevelSchema = z.enum(FACT_REVIEW_LEVELS);

export const FactEvidenceSchema = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('DOCUMENT'), documentId: z.string(), page: z.number().int().positive().nullable() }),
  z.object({ kind: z.literal('EXTERNAL'), source: z.string(), date: z.string() }),
]);

export const FactProvenanceSchema = z.object({
  origin: FactOriginSchema,
  status: FactStatusSchema,
  reviewLevel: FactReviewLevelSchema,
  confirmation: z.object({ memberId: z.string(), confirmedAt: z.string() }).nullable(),
  evidence: FactEvidenceSchema.nullable(),
  timeReference: z.string().nullable(),
  reason: z.string().nullable(),
});

export type FactEvidenceDto = z.infer<typeof FactEvidenceSchema>;
export type FactProvenanceDto = z.infer<typeof FactProvenanceSchema>;
